import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import { addItemsTabWarnings, deleteItemsTabWarnings } from '../../../commonActions/serverErrorAction'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import { saveLineItemFeild, updateLineItemFeild } from '../../actions'
import { getValidationError as ValidationError } from '../../Helper';
import { REGIME_CODE,COMP_REGIME_CODES,PKG_COUNT,PKG_TYPE} from '../../Helper/formLabel';
import usePdiEnable from '../../hooks/usePdiEnable'

const MerchForm4 = (props) => {
  const {
    lineItemIndex,
    packageCount,
    isFormDisabled,
    packageType,
    invoiceIndex,
    translate,
    procedure,
    invoiceId,
    procedureSuffix,
    regimeAdditionalCode,
    merchandiseId
  } = props
  const dispatch = useDispatch()
  const { isImportShipment,customJobState } = useCurrentShipmentType()
  const pdiValidationCheck = customJobState?.includes("PDI");


  const box37AregimeCodesList = useSelector((state) => state.DropDownValues[isImportShipment ? "box37_1a_regimeCodes" : "box37aExport"])
  const box37BregimeCodesList = useSelector((state) => state.DropDownValues[isImportShipment ? "box37_1b_regimeCodes" : "box37bExport"])

  const packageCodes = useSelector((state) => state.DropDownValues.packageCodes)
  const box37ComplementaryRegimeCodes = useSelector((state) => state.DropDownValues.box37ComplementaryRegimeCodes)
  const getValidationError=(field, value, Level, onlyMandatoryCheck)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate,pdiValidationCheck)

  
  const addErrors = (level, value, fieldName) => dispatch(addItemsTabWarnings(level, value, fieldName))
  
  const deleteErrors = (level, value, fieldName) => dispatch(deleteItemsTabWarnings(level, value, fieldName))
  
  const pdiDisabled = usePdiEnable();
  return (
    <Grid.Row>
      <Grid.Column width='4' className='divFormFeild b-rw-0  '>
        <DropDown
          id={`regimeCode-${invoiceId}-${merchandiseId}`}
          disabled={isFormDisabled}
          {...pdiDisabled}
          boxNumber='37.1 A'
          className='field-bg dropdown100 '
          label={translate(REGIME_CODE, { ns: ['default', 'lineItem'] })}
          labelClass='text-none'
          isLabel={true}
          clerarable
          data={box37AregimeCodesList}
          value={procedure}
          errors={getValidationError('procedure', procedure, 'itemsTab', true)}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { procedure: value?.trim() }))
            dispatch(saveLineItemFeild(merchandiseId, ['procedure', 'procedureSuffix'], invoiceId))
            let err = getValidationError('procedure', value, 'itemsTab', true)
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `procedure-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `procedure-${merchandiseId}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='4' className='divFormFeild b-rw-0  '>
        <DropDown
          id={`compRegimeCodes-${invoiceId}-${merchandiseId}`}
          label={translate(COMP_REGIME_CODES, { ns: ['default', 'lineItem'] })}
          disabled={isFormDisabled}
          {...pdiDisabled}
          boxNumber='37.1 B'
          className='field-bg dropdown100'
          labelClass='text-none'
          mandatory={false}
          clearable
          isLabel={true}
          data={box37BregimeCodesList}
          value={procedureSuffix}
          errors={getValidationError('procedureSuffix', procedureSuffix, 'itemsTab', true)}
          onChange={(value) => {
            dispatch(
              updateLineItemFeild(invoiceId, merchandiseId, { procedureSuffix: value?.trim() })
            )
            dispatch(saveLineItemFeild(merchandiseId, ['procedure', 'procedureSuffix'], invoiceId))
            let err = getValidationError('procedureSuffix', value, 'itemsTab', true)
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `procedureSuffix-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `procedureSuffix-${merchandiseId}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className={`divFormFeild b-rw-0`}>
        <DropDown
          id={`regimeAdditionalCode-${invoiceId}-${merchandiseId}`}
          boxNumber='37.2'
          disabled={isFormDisabled}
          className={'field-bg dropdown100'}
          labelClass='text-none'
          direction={'right'}
          mandatory={false}
          data={box37ComplementaryRegimeCodes}
          value={regimeAdditionalCode}
          clearable
          isLabel={true}
          label={translate('REGIME_ADD_CODE', { ns: ['default', 'lineItem'] })}
          onChange={(value) => {
            dispatch(
              updateLineItemFeild(invoiceId, merchandiseId, {
                regimeAdditionalCode: value?.trim(),
              })
            )
            dispatch(saveLineItemFeild(merchandiseId, 'regimeAdditionalCode', invoiceId))
          }}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild b-rw-0  '>
        <InputField
          isLabel={false}
          id={`packageCount-${invoiceId}-${merchandiseId}`}
          type='number'
          boxNumber='31'
          label={translate(PKG_COUNT, { ns: ['default', 'lineItem'] })}
          mandatory={false}
          value={parseFloat(packageCount)}
          errors={getValidationError('packageCount', packageCount, 'itemsTab')}
          className={'field-bg dropdown100'}
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { packageCount: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'packageCount', invoiceId))
            let err = getValidationError('packageCount', packageCount, 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `packageCount-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `packageCount-${merchandiseId}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild '>
        <DropDown
          id={`packageType-${invoiceId}-${merchandiseId}`}
          boxNumber='31'
          disabled={isFormDisabled}
          className={'field-bg dropdown100'}
          direction={'left'}
          labelClass='text-none'
          isLabel={true}
          value={packageType}
          data={packageCodes}
          label={translate(PKG_TYPE, { ns: ['default', 'lineItem'] })}
          errors={getValidationError('packageType', packageType, 'itemsTab', true)}
          clearable
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { packageType: value?.trim() }))
            dispatch(saveLineItemFeild(merchandiseId, 'packageType', invoiceId))
            let err = getValidationError('packageType', value, 'itemsTab', true)
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `packageType-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `packageType-${merchandiseId}`)
          }}
        />
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(MerchForm4)
